<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <FormInput label="Descripción" name="descripcion" rules="required" v-model="descuento.descripcion" />
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="precio">Precio</label>
                    <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                        <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Precio" v-model="descuento.precio"/>
                        <small>
                            Gastos de gestión no incluidos -
                            <span v-if="gd_online['interno'] == 1">
                                (Online: 0€ / {{ parseFloat(descuento.precio) | formatear_precio }}) -
                            </span>
                            <span v-else>
                                (Online: {{ gd_online }}€ / {{ parseFloat(descuento.precio) + parseFloat(gd_online) | formatear_precio }}) -
                            </span>

                            <span v-if="gd_taquilla['interno'] == 1">
                                (Taquilla: 0€ / {{ parseFloat(descuento.precio) | formatear_precio }})
                            </span>
                            <span v-else>
                                (Taquilla: {{ gd_taquilla }}€ / {{ parseFloat(descuento.precio) + parseFloat(gd_taquilla) | formatear_precio }})
                            </span>
                        </small>
                        <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-6">
                <FormInput label="Edad mínima"  :disabled="!empty(descuento.fecha_nacimiento_minima) || !empty(descuento.fecha_nacimiento_maxima)" name="edad_minima" v-model="descuento.edad_minima" />
            </div>
            <div class="col-6">
                <FormInput label="Edad máxima"  :disabled="!empty(descuento.fecha_nacimiento_minima) || !empty(descuento.fecha_nacimiento_maxima)" name="edad_maxima" v-model="descuento.edad_maxima" />
            </div>
            <div class="col-6">
                <FormInput label="FECHA NACIMIENTO MÍNIMA" ejemplo="(ejemplo 01/01/1990)" type="date" :disabled="!empty(descuento.edad_minima) || !empty(descuento.edad_maxima)" name="fecha_edad_minima" v-model="descuento.fecha_nacimiento_minima" />
            </div>
            <div class="col-6">
                <FormInput label="FECHA NACIMIENTO MÁXIMA" ejemplo="(ejemplo 31/12/2003)"  type="date" :disabled="!empty(descuento.edad_minima) || !empty(descuento.edad_maxima)" name="fecha_edad_maxima" v-model="descuento.fecha_nacimiento_maxima" />
            </div>
            <div class="col-12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox2" v-model="descuento.show_online"/>
                    <label for="customCheckbox2" class="custom-control-label">Ver online</label>
                </div>
            </div>
            <div class="col-12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox3" v-model="descuento.renovacion"/>
                    <label for="customCheckbox3" class="custom-control-label">Precio de renovación</label>
                </div>
            </div>
            <div class="col-12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox4" v-model="descuento.solicitar_documentacion"/>
                    <label for="customCheckbox4" class="custom-control-label">Solicitar documentación</label>
                </div>
            </div>
            <div class="col-12 mt-3" v-if="descuento.solicitar_documentacion">
                <div class="form-group">
                    <label>Texto documentación</label>
                    <ValidationProvider name="texto_documentacion" rules="required" v-slot="{ errors }">
                        <textarea :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" rows="3" placeholder="Texto documentación" v-model="descuento.texto_documentacion"></textarea>
                        <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 mt-3">
                <Button type="submit" name="button">Continuar</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['descuento'],
        data() {
            return {
            }
        },
        computed: {
            gd_online() {
                var gd = this.$store.getters.getGd['venta_abono_online'];

                var cantidad = gd['cantidad'];

                if(gd['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.descuento.precio * cantidad; 
                }

                cantidad = this.round(cantidad, 2);

                if(gd['interno']) {
                    return cantidad;
                } else {
                    return cantidad;
                }
            },
            gd_taquilla() {
                var gd = this.$store.getters.getGd['venta_abono_fisica'];

                var cantidad = gd['cantidad'];

                if(gd['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.descuento.precio * cantidad; 
                }

                cantidad = this.round(cantidad, 2);

                if(gd['interno']) {
                    return cantidad;
                } else {
                    return cantidad;
                }
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado');
                }
            },
            round(num, decimales = 2) {
                var signo = (num >= 0 ? 1 : -1);
                num = num * signo;
                if(decimales === 0) //con 0 decimales
                    return signo * Math.round(num);
                // round(x * 10 ^ decimales)
                num = num.toString().split('e');
                num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
                // x * 10 ^ (-decimales)
                num = num.toString().split('e');
                return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
            },
            empty(value) {
                return _.isEmpty(value);
            }
        },
    }
</script>
